import Immutable from 'immutable';
const LOAD = 'managemanageHelp/LOAD';
const LOAD_IMAGES = 'manageHelp/LOAD_IMAGES';
const LOAD_SUCCESS = 'manageHelp/LOAD_SUCCESS';
const LOAD_IMAGES_SUCCESS = 'manageHelp/LOAD_IMAGES_SUCCESS';
const LOAD_FAIL = 'manageHelp/LOAD_FAIL';
const LOAD_SAVE_FORM = 'manageHelp/LOAD_SAVE_FORM';
const CLOSE_ERROR_MESSAGE = 'manageHelp/CLOSE_ERROR_MESSAGE';

const initialState = Immutable.fromJS({
  isLoad: false,
  isLoadImages: false,
  loadErr: null,
  loading: false
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_IMAGES:
      return state
        .set('isLoadImages', action.res);

    case CLOSE_ERROR_MESSAGE:
      return state
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('manageHelp', action.res);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('schedule', null);

    case LOAD_SAVE_FORM:
      return state
        .set('isLoad', false)
        .set('loadErr', null);

    default:
      return state;
  }
};

export const hideErrorModal = () => async (dispatch, getState, api) => {
  dispatch({ type: CLOSE_ERROR_MESSAGE, action: null });
}

export const saveForm = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.put(`/account/updateDoctorProfile`, {data: obj});
    dispatch({ type: LOAD_SAVE_FORM, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};
